module.exports = __webpack_public_path__ + "img/Rogel-Vertical.9869c5cb.png";